<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="h-[80%] overflow-hidden"
    position="bottom"
    teleport="body"
    closeable
  >
    <VanTabs
      v-model:active="activeTab"
      class="mt-1 h-full modal-friend-mate-select"
    >
      <VanTab title="我的 OC" v-if="showMyMate">
        <div class="p-4 flex flex-wrap gap-2">
          <div
            v-for="item in mateStore.list.filter(
              (item) => !props.exclude?.includes(item.id)
            )"
            :key="item.id"
            @click="emit('select', item)"
            class="flex flex-col items-center overflow-hidden w-12 gap-1"
          >
            <div class="w-10">
              <UserAvatar :mate="item" />
            </div>
            <div class="line-clamp-1">{{ useName(item.name) }}</div>
          </div>
        </div>
      </VanTab>
      <VanTab title="相识的 OC">
        <ThreadList
          ref="reviewListRef"
          :on-pull-load="reload"
          :on-scroll-load="loadNextPage"
          class="h-full"
        >
          <div class="p-4 flex flex-wrap gap-2">
            <div
              v-if="sender && mateList.length === 0 && !loading"
              class="flex flex-col items-center justify-center w-full gap-2"
            >
              <p class="text-base-content/70">
                暂无好友，让OC娃去溜达认识点好友吧
              </p>
              <button class="btn btn-primary btn-sm" @click="clickAddFriend">
                去溜达
              </button>
            </div>
            <div
              v-for="item in showMyMateList"
              :key="item.id"
              @click="emit('select', item)"
              class="flex flex-col items-center overflow-hidden w-12 gap-1"
            >
              <div class="w-10">
                <UserAvatar :mate="item" />
              </div>
              <div class="line-clamp-1">{{ useName(item.name) }}</div>
            </div>
          </div>
        </ThreadList>
      </VanTab>
    </VanTabs>
  </VanPopup>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { ThreadListInstance } from "../ThreadList.vue";
import { Mate } from "@/types/entity";
import api from "@/modules/api";
import { useName } from "@/use/common";
import { useRouter } from "vue-router";
import { ApiGetMateRelationshipPage } from "@/apis/interaction";
import { useMate } from "@/stores/mate";
import { DispatchType } from "@/enums/mission";
const props = defineProps<{
  show: boolean;
  sender?: Mate;
  showMyMate?: boolean;
  exclude?: number[];
}>();
const emit = defineEmits<{
  (event: "update:show", value: boolean): void;
  (event: "select", value: Mate): void;
}>();

const perPage = 50;
const reviewListRef = ref<ThreadListInstance>();
const router = useRouter();
const mateList = ref<Mate[]>([]);
const loading = ref(false);
const activeTab = ref(0);
const mateStore = useMate();
const reload = async () => {
  mateList.value = [];
  loading.value = true;
  reviewListRef.value?.resetScrollLoadingState();
};

const showMyMateList = computed(() => {
  return mateList.value.filter((item) => !props.exclude?.includes(item.id));
});

watch(
  () => props.show,
  (newVal) => {
    if (newVal) reload();
  },
  { immediate: true, deep: true }
);

const loadNextPage = async () => {
  const { length } = mateList.value;
  const page = Math.floor(length / perPage) + 1;
  if (length !== 0 && length % perPage !== 0) {
    loading.value = false;
    return false;
  }
  if (props.sender) {
    const res = await ApiGetMateRelationshipPage({
      pagination: {
        page,
        perPage,
      },
      filter: {
        targetType: "others",
        sourceMateId: props.sender.id,
      },
      sort: {
        field: "dtUpdate",
        order: "desc",
      },
    });
    for (const { targetMate } of res.page.data) {
      if (targetMate) {
        mateStore.friendMateMap.set(targetMate.id, targetMate);
        // if (!props.exclude?.includes(targetMate.id)) {
        mateList.value.push(targetMate);
        // }
      }
    }
    loading.value = false;
    return res.page.data.length === perPage;
  } else {
    const res = await api.readMateAdmiringPage({
      pagination: {
        page,
        perPage,
      },
      sort: {
        field: "dtUpdate",
        order: "desc",
      },
    });

    mateList.value.push(...res.page.data);
    loading.value = false;
    return res.page.data.length === perPage;
  }
};

const clickAddFriend = () => {
  emit("update:show", false);

  router.push({
    name: "missionEdit",
    query: {
      hostUuid: props.sender?.uuid,
      type: DispatchType.Stroll,
    },
  });
};
</script>

<style scoped>
:deep(.modal-friend-mate-select .van-tabs__content) {
  height: 100%;
}
</style>
